import { Skeleton, Tabs } from 'antd'
import styles from './index.module.less'
import { useDebounceEffect, useSetState } from 'ahooks'
import { getUCenterAppList, getUCenterAppTypeList } from '@/services'
// import { getTenantId } from '@/common/utils.ts'
import useWorkshopStore from '@/store/workshop.ts'
import { useShallow } from 'zustand/react/shallow'
import ApplicationList from '@/pages/workshop/ApplicationSection/ApplicationList.tsx'
import useGlobalStore from '@/store'
import { useEffect } from 'react'
import useAuthMenu from '@/hooks/useAuthMenu.ts'

const ApplicationSection = () => {
  const [state, setState]: any = useSetState({
    appType: [],
    // appList: [],
    loading: false,
  })

  const { setAppType, appType, appTypeList, setAppTypeList, appList, appLoading } =
    useWorkshopStore(
      useShallow((state: any) => ({
        setAppType: state.setAppType,
        appType: state.appType,
        appTypeList: state.appTypeList,
        setAppTypeList: state.setAppTypeList,
        appList: state.appList,
        appLoading: state.appLoading,
      }))
    )

  const { menuLoading, globalMenu } = useGlobalStore(
    useShallow((state: any) => ({
      menuLoading: state.menuLoading,
      globalMenu: state.menu,
    }))
  )

  const authMenu = useAuthMenu(appList)

  useEffect(() => {
    const appType =
      appTypeList
        .filter(t => authMenu.find(d => d.app.categoryId === t.id || !t.id))
        .map(d => ({
          key: d.id || `ALL`,
          label: d.name,
        })) || []
    setState({ appType })
  }, [appTypeList, authMenu])

  useDebounceEffect(
    () => {
      getUCenterAppTypeList().then(appTypeList => {
        // setState({ appType })
        setAppTypeList(appTypeList)
      })

      // getUCenterAppList({
      //   tenantId: getTenantId(),
      //   appType: 'OFFICIAL',
      // })
      //   .then(res => {
      //     // setState({ appList: res })
      //     setAppList(res)
      //   })
      //   .finally(() => {
      //     setState({ loading: false })
      //   })
    },
    [],
    { wait: 200 }
  )

  const onTabChange = activeKey => {
    const appType = appTypeList.find(d => d.id === activeKey) || null
    setAppType(appType)
  }

  // console.log('globalMenu', globalMenu, menuLoading, appLoading, appLoading || menuLoading || !globalMenu.length)
  return (
    <div className={styles.applications}>
      <Tabs
        size="small"
        tabBarStyle={{ padding: '0 15px' }}
        defaultActiveKey={'ALL'}
        activeKey={appType?.id || 'ALL'}
        onChange={onTabChange}
        items={[
          // {
          //   key: 'RECENT_USE',
          //   label: '最近使用',
          //   children: '',
          // },
          ...state.appType,
        ]}
      />
      {appLoading || menuLoading || !globalMenu.length ? (
        <div style={{ margin: '0 10px' }}>
          <Skeleton active />
        </div>
      ) : (
        <ApplicationList filterType={appType} dataSource={authMenu} spanProps={{ span: 8, xxl: 6 }} />
      )}
    </div>
  )
}

export default ApplicationSection
